export enum RequestStatusType {
  COMPLETED = 1,
  EXECUTION = 2,
  APPROVAL = 3,
  REFUSED = 4,
  ERROR = 5,
  _EXECUTION = 6,
  RETRY = 7,
}

export const REQUEST_STATUS_LIST = [
  {
    label: "COMPLETED",
    value: 1,
  },
  {
    label: "EXECUTION",
    value: 2,
  },
  {
    label: "APPROVAL",
    value: 3,
  },
  {
    label: "REFUSED",
    value: 4,
  },
  {
    label: "ERROR",
    value: 5,
  },
  {
    label: "_EXECUTION",
    value: 6,
  },
  {
    label: "RETRY",
    value: 7,
  },
];

export const TASK_REQUEST_STATUS_LIST = [
  {
    label: "COMPLETED",
    value: 1,
  },
  {
    label: "EXECUTION",
    value: 2,
  },
  {
    label: "APPROVAL",
    value: 3,
  },
  {
    label: "REFUSED",
    value: 4,
  },
  {
    label: "ERROR",
    value: 5,
  },
  {
    label: "_EXECUTION",
    value: 6,
  },
];

export enum CertificationStatusType {
  COMPLETED = 1,
  IN_PROGRESS = 2,
  SCHEDULED = 3,
  CLOSED = 4,
  STARTING = 5,
}

export enum TechUserStatusType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const TECH_USER_STATUS_LIST = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
  },
];
